import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { DatabaseService } from './db-service';

@Injectable({
  providedIn: 'root'
})

export class DocumentService {
    constructor(
        private afstore: AngularFirestore,
        private databaseService: DatabaseService) {
    }

    public getDocument(collection: string, docId: string) {
        return this.databaseService.getDocument(`${collection}/${docId}`);
    }

    public async getDocumentById(collection: string, docId: string) {
        return await this.databaseService.getDocumentById(collection, docId);
    }

    public deleteDocument(collection: string, docId: string) {
        return this.afstore
            .collection(collection)
            .doc(docId)
            .set({ isDeleted: true }, { merge: true });
    }

    public updateDocument(collection: string, document: any) {
        return this.afstore
            .collection(collection)
            .doc(document.id)
            .set(document, { merge: true });
    }
}
